export default "__VITE_ASSET__CaACs2LS__"